import { useEffect } from 'react'
import { delay, isArray, toString } from 'lodash'
import { DealerCard } from './DealerCard'
import { useSelector } from '@ggs/store'
import { scrollTo } from '@ggs/utils'

/**
 * @typedef {import('../../../definitions').DealerEntity} DealerEntity
 */

/**
 * @typedef {Object} DealerLocatorListProps
 * @property {DealerEntity[]} dealers
 */

/**
 * Dealer locator sidebar listing.
 * @param {DealerLocatorListProps} props
 * @return {JSX.Element}
 */
export const DealerLocatorList = ({ dealers }) => {
  const selectedDealerId = useSelector((state) => state.ui.searchDealer?.selectedResultId || '')

  useEffect(() => {
    if (selectedDealerId) {
      const cardId = `dealer-card-${selectedDealerId}`
      delay(() => scrollTo.elementById(cardId), 200)
    }
  }, [selectedDealerId])

  if (!isArray(dealers)) {
    return null
  }

  return (
    <>
      {dealers.map((dealer, index) => {
        const isSelected = selectedDealerId === toString(dealer.id)
        return (
          <DealerCard
            key={dealer.id}
            dealer={dealer}
            listingIndex={index + 1}
            isSelected={isSelected}
          />
        )
      })}
    </>
  )
}
